// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"0c18a80e","38":"1fe6c344","777":"0823185a"}[chunkId] + ".chunk.js";
};